import { Injectable } from '@angular/core';
import { SalesByClientsCollectionQuery, SalesByClientsCollectionQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByClientsCollectionQuery)
@Wrapper(SalesByClientsCollectionQueryHandlerBase)
export class SalesByClientsCollectionQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
